import { CalendarDays, Gavel } from 'lucide-react';
import { LIB_LABEL, fmtDate, formatSanctions, stripHtml, type Decision } from '@generated/lib/decision-utils';

export function DecisionCard({ d, onOpen }: { d: Decision; onOpen: () => void }) {
  const sanctions = formatSanctions(d);
  return (
    <button onClick={onOpen} className="glass-card group flex min-w-0 flex-col rounded-2xl p-5 text-left transition hover:-translate-y-0.5 hover:border-primary/25">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-primary">{d.lib === 'itp' ? 'Hockey Canada' : d.sport || LIB_LABEL[d.lib]}</p>
          <h3 className="mt-1 truncate text-lg font-semibold text-secondary">{d.name}</h3>
        </div>
        {d.finding[0] && <span className="shrink-0 rounded-full bg-primary/10 px-2.5 py-1 text-[11px] font-medium text-primary">{d.finding[0]}</span>}
      </div>
      <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-muted-foreground">{stripHtml(d.summary) || 'No summary recorded.'}</p>
      <div className="mt-auto flex flex-wrap items-center gap-x-4 gap-y-1 pt-4 text-xs text-muted-foreground">
        <span className="flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" />{fmtDate(d.date)}</span>
        {d.lib === 'itp' && d.sport && <span>{d.sport}</span>}
        {d.province && <span className="truncate">{d.province}</span>}
      </div>
      {sanctions.length > 0 && (
        <p className="mt-2 flex items-center gap-1 truncate text-xs font-medium text-secondary"><Gavel className="h-3.5 w-3.5 shrink-0 text-primary" /><span className="truncate">{sanctions.join(' · ')}</span></p>
      )}
    </button>
  );
}
